

































































import {Component, Vue} from 'vue-property-decorator';
import {WaccaLocation} from '@/model/WaccaLocation';

const qqMapKey = '6DGBZ-MGSWU-P4UVD-4MAWX-6ADZS-JEBR5';

@Component({
  components: {
  },
})
export default class Location extends Vue{
  displayStore: WaccaLocation[] = [];
  store: WaccaLocation[] = [];

  resultString = '';

  region: string[] = [
  ]
  selectedRegion = '0';

  mapScript?: HTMLScriptElement;

  created(): void {
    this.$axios.get('wacca/locations').then(resp => {
      this.store = resp.data;

      const regionSet = new Set<string>();
      this.store.forEach(s => {
        regionSet.add(s.cities.split(';')[0]);
      });
      const region: string[] = [];
      regionSet.forEach(r => region.push(r))
      this.region = region;
      this.displayStore = this.store;
      this.resultString = '店铺数:' + this.displayStore.length;
    })
  }

  mounted(): void {
    // const mapContainer = this.$refs.map;
    // if (!this.mapScript) {
    //   const qqmap = document.createElement('script');
    //   this.mapScript = qqmap;
    //   qqmap.type = 'text/javascript';
    //   qqmap.src = 'https://map.qq.com/api/gljs?v=1.exp&key=OB4BZ-D4W3U-B7VVO-4PJWW-6TKDJ-WPB77';
    //   // qqmap.onload = () => {
    //   //   //定义地图中心点坐标
    //   //   const TMap = (window as any).TMap;
    //   //   const center = new TMap.LatLng(39.984120, 116.307484)
    //   //   //定义map变量，调用 TMap.Map() 构造函数创建地图
    //   //   const map = new TMap.Map(mapContainer, {
    //   //     center: center,//设置地图中心点坐标
    //   //     zoom: 17.2,   //设置地图缩放级别
    //   //     rotation: 45    //设置地图旋转角度
    //   //   });
    //   // }
    //   document.body.appendChild(qqmap);
    // }
  }

  beforeDestroy(): void {
    if (this.mapScript) {
      document.body.removeChild(this.mapScript);
      this.mapScript = undefined;
    }
  }

  getLocation(): void {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(data => {
        this.$jsonp('https://apis.map.qq.com/ws/geocoder/v1/', {
          location: `${data.coords.latitude},${data.coords.longitude}`,
          key: qqMapKey,
          output: 'jsonp'
        }).then(l => {
          if (l.result) {
            const province = l.result.address_component.province;
            this.displayStore = this.store.filter(v => v.cities.startsWith(l.result.address_component.province));
            this.resultString = `${province}的搜索结果${this.displayStore.length > 0 ? ', 店铺数:' + this.displayStore.length : ''}`;
          }
        })
      }, () => alert('没有定位权限或者定位失败'));
    } else {
      alert('您使用的浏览器不支持定位');
    }
  }

  filterByRegion(): void {
    this.resultString = '';
    const i = Number(this.selectedRegion) - 1;
    if (i == -1) {
      this.displayStore = this.store;
      this.resultString = '店铺数:' + this.displayStore.length;
    } else {
      const reg = this.region[i];
      this.displayStore = this.store.filter(v => v.cities.startsWith(reg));
      this.resultString = '店铺数:' + this.displayStore.length;
    }
  }

  goToMap(item: WaccaLocation): void {
    const address = item.cities.split(';').join('') + item.address;
    window.location.href = `   https://apis.map.qq.com/uri/v1/marker?marker=coord:${item.latitude},${item.longitude};title:${item.name};addr:${item.address}&referer=${qqMapKey}`
  }

}
